module.exports = __webpack_public_path__ + "img/hint-four-mobile.4cdff552.png";